/**
 * SIMO-OWNER-CONTROL-PLANE-ACCEPTANCE-RECOVERY-1 §4 — echte, bookmark- und
 * refresh-faehige Navigation fuer die SimoT-Standalone-App (`?product=simot`).
 *
 * Bisher war die aktive Surface nur React-State (`useState("mission")`) —
 * Reload sprang zurueck auf Mission Console und Agent Room war nicht
 * verlinkbar. Kanonische Loesung ohne neue Router-Dependency: Hash-Routes
 * (`#/agent-room`, `#/mission`, ...). Sie ueberleben Reload, sind
 * bookmarkbar, deep-linkbar und laufen korrekt durch Back/Forward
 * (hashchange feuert bei beiden). Der `?product=simot`-Query bleibt
 * unberuehrt (Electron-Shell haengt ihn an BASE_UI_URL an).
 */

export type SimoTSurface = "mission" | "agent-room" | "workspace" | "projects" | "cockpit" | "audit";

export const SIMOT_SURFACES: readonly SimoTSurface[] = [
  "mission",
  "agent-room",
  "workspace",
  "projects",
  "cockpit",
  "audit",
];

export const SIMOT_DEFAULT_SURFACE: SimoTSurface = "mission";

export function surfaceToHash(surface: SimoTSurface): string {
  return `#/${surface}`;
}

export function surfaceFromHash(hash: string): SimoTSurface {
  const raw = hash.replace(/^#\/?/, "").split(/[/?#]/)[0]?.trim().toLowerCase() ?? "";
  return (SIMOT_SURFACES as readonly string[]).includes(raw) ? (raw as SimoTSurface) : SIMOT_DEFAULT_SURFACE;
}
